import { format } from "date-fns";

export default function TenderDocumentsTable({ documents, actionButton }) {
  return (
    <div className="bg-white rounded-lg border border-gray-200">
      <div className="px-6 py-4 flex justify-between items-center border-b border-gray-200">
        <div className="flex items-center gap-2">
          <h2 className="text-base text-gray-900 font-semibold">Documents</h2>
          <span className="bg-blue-50 font-medium border border-blue-300 text-blue-600 text-xs px-2 py-0.5 rounded-full">
            {documents.length} Files
          </span>
        </div>
        {actionButton}
      </div>

      <table className="min-w-full divide-y divide-gray-200">
        <thead>
          <tr className="bg-gray-50">
            <th
              scope="col"
              className="px-6 py-3 text-left text-xs font-medium text-gray-500"
            >
              File name
            </th>
            <th
              scope="col"
              className="px-6 py-3 text-left text-xs font-medium text-gray-500"
            >
              File size
            </th>
            <th
              scope="col"
              className="px-6 py-3 text-left text-xs font-medium text-gray-500"
            >
              Date uploaded
            </th>
            <th
              scope="col"
              className="px-6 py-3 text-left text-xs font-medium text-gray-500"
            >
              File Type
            </th>
            <th
              scope="col"
              className="px-6 py-3 text-left text-xs font-medium text-gray-500"
            >
              Required Response
            </th>
            <th scope="col" className="w-8 px-6 py-3"></th>
          </tr>
        </thead>
        <tbody className="divide-y divide-gray-200 bg-white">
          {documents.map((document) => (
            <tr key={document.id} className="hover:bg-gray-50">
              <td className="px-6 py-4">
                <div className="flex items-center gap-2">
                  <img
                    src={`/file-extension-icons/${document.document_path
                      .split(".")
                      .pop()}.png`}
                    alt={document.name}
                    className="w-8 h-8"
                  />
                  <div className="flex flex-col ">
                    <span className="text-xs font-medium text-gray-900">
                      <a
                        href={document.document_path}
                        target="_blank"
                        rel="noopener noreferrer"
                        className="text-blue-500 flex items-center gap-1"
                      >
                        <div className="flex min-w-0 flex-1">
                          <span className="truncate text-ellipsis font-medium">
                            {document.name}
                          </span>
                        </div>
                      </a>
                    </span>
                    <span className="text-xs text-gray-500">
                      {document.file_size}
                    </span>
                  </div>
                </div>
              </td>
              <td className="px-6 py-4 text-xs text-gray-500">
                {document.file_size}
              </td>
              <td className="px-6 py-4 text-xs text-gray-500">
                {document.created_at
                  ? format(new Date(document.created_at), "MMM d, yyyy")
                  : "N/A"}
              </td>
              <td className="px-6 py-4 text-xs text-gray-500">
                {document.document_type}
              </td>
              <td className="px-6 py-4">
                <span
                  className={`text-xs ${
                    document.required_response === "Yes"
                      ? "text-blue-600"
                      : "text-gray-500"
                  }`}
                >
                  {document.required_resubmit ? "Yes" : "No"}
                </span>
              </td>
            </tr>
          ))}
        </tbody>
      </table>
    </div>
  );
}
